import React from "react";
import ContactIllustration from "../components/images/Online consulting-bro 1.svg";

const ContactSection = () => {
  return (
    <section className="bg-black min-h-screen flex flex-col items-center justify-center relative">
      {/* Header Section (Top Right) */}
      <div className="absolute top-10 right-60 text-right">
        <h1 className="text-5xl font-extrabold mb-2">
          Get in <span className="text-purple-400">touch</span>
        </h1>
        <p className="text-lg text-white">
          Reach out, and let’s create a universe of possibilities together!
        </p>
      </div>

      {/* Form Container */}
      <div className="flex bg-gray-800 rounded-xl shadow-xl p-10 items-center justify-between max-w-5xl w-full mt-16 ml-80">
      {/* Left: Form Section */}
        <div className="w-1/2">
          <div className="text-left mb-6">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Let’s connect constellations
            </h2>
            <p className="text-gray-400">
              Let’s align our constellations! Reach out and let the magic of
              collaboration illuminate our skies.
            </p>
          </div>

          <form className="space-y-4">
            <div className="flex space-x-4">
              <input
                type="text"
                placeholder="Last Name"
                className="w-1/2 p-3 rounded-lg bg-gray-900 text-white placeholder-gray-500"
              />
              <input
                type="text"
                placeholder="First Name"
                className="w-1/2 p-3 rounded-lg bg-gray-900 text-white placeholder-gray-500"
              />
            </div>

            <input
              type="email"
              placeholder="Email"
              className="w-full p-3 rounded-lg bg-gray-900 text-white placeholder-gray-500"
            />

            <input
              type="text"
              placeholder="Phone Number"
              className="w-full p-3 rounded-lg bg-gray-900 text-white placeholder-gray-500"
            />

            <textarea
              placeholder="Message"
              className="w-full p-3 rounded-lg bg-gray-900 text-white placeholder-gray-500 h-32"
            ></textarea>

            <button className="w-full bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-4 rounded-lg transition duration-300 ease-in-out">
              Send it to us 🚀
            </button>
          </form>
        </div>

        {/* Right: Image Section */}
        <div className="w-1/2 flex justify-center">
          <img
            src={ContactIllustration}
            alt="Contact Illustration"
            className="w-3/4 h-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
